import { isEmpty } from '@ember/utils';
import moment from 'moment';

export function toCamelCase(str: string | null | undefined): string {
  if (!str) {
    return '';
  }

  return str
    .replace(/[_-]/g, ' ') // Convert underscores and dashes to spaces (word boundaries)
    .trim() // Remove any leading/trailing space caused by replacing dashes/underscores to spaces
    .replace(/[^a-z0-9 ]/gi, '') // Remove remaining non-alphanumeric characters
    .replace(
      /(?:^\w|[A-Z]|\b\w|\s+)/g,
      function (match: string, index: number) {
        if (/\s+/.test(match)) {
          return '';
        }
        // lowercase if first letter, otherwise uppercase.
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
      },
    );
}

export function isTruthy(val: string): boolean {
  switch (val.toLowerCase().trim()) {
    case 'y':
    case 'ye':
    case 'yes':
    case 'true':
    case '1':
      return true;
    default:
      return false;
  }
}

export function conformDate(str: string | null | undefined): string {
  if (isEmpty(str)) {
    return '';
  }
  const parsed = moment(str, [
    'YYYY-MM-DD',
    'DD/MM/YYYY',
    'MM/DD/YYYY',
    'YYYYMMDD',
  ]);
  if (parsed.isValid()) {
    return parsed.format('YYYY-MM-DD');
  } else {
    return '';
  }
}

export function convertParagraphsToListItems(html: string): string {
  // Replace non-empty <p> tags with <li> tags
  html = html.replace(
    /<p[^>]*>(.*?)<\/p>/gi,
    function (_match: string, content: string) {
      // Check if the content inside the <p> tag is empty
      if (content.trim() === '') {
        return ''; // Remove empty <p> tags
      } else {
        return '<li>' + content + '</li>'; // Replace non-empty <p> tags with <li> tags
      }
    },
  );
  return html;
}
